export default __webpack_public_path__ + "static/media/warehouses.3cbcd5d3.png";